import cn from 'classnames'

import { ChevronDownIcon } from '@components/icons/ChevronDownIcon'
import {
  WritersPaymentStatusEnum,
  WritersPaymentStatusValue,
} from '@interfaces/WritersPaymentStatusEnum'
import { SHOW_EBOOK_FEATURE } from '@configs/config'
import { Table } from '../Table'
import { TableRowProps } from './interface'

export function TableRow({
  writerIncomeNovelChapter,
  writerIncomeNovelEbook,
  writerIncomeMangaChapter,
  writerIncomeMangaEbook,
  writerIncomeDonation,
  writerIncomeSummary,
  writerIncomeCumulative,
  paidAfterDeductWithholdingTax,
  withholdingTax,
  totalIncomeBeforeDeductWithholdingTax,
  status,
  paymentCycleMonth,
  paymentCycleYear,
  paidAt,
  createdAt,
  isShowSubRow,
  getMonth,
  formatDate,
  handleToggleShowSubRow,
}: TableRowProps) {
  return (
    <>
      <Table.Row
        className='border-b border-b-gray-3 dark:border-b-purple'
        onClick={handleToggleShowSubRow}
      >
        <Table.Column className='py-[22px] dark:text-dark-10'>
          <div>
            {getMonth(paymentCycleMonth)} {paymentCycleYear}
          </div>
        </Table.Column>

        <Table.Column className='py-[22px] dark:text-dark-10'>
          <div>{formatDate(createdAt)}</div>
        </Table.Column>

        <Table.Column
          className={cn('py-[22px] font-bold', {
            'text-secondary-1 dark:text-dark-10':
              status === WritersPaymentStatusEnum.PENDING,
            'text-primary':
              status === WritersPaymentStatusEnum.CUMULATIVE ||
              status === WritersPaymentStatusEnum.ACCUMULATED ||
              status === WritersPaymentStatusEnum.COMPLETE,
            'text-red': status === WritersPaymentStatusEnum.ERROR,
          })}
        >
          <div>{WritersPaymentStatusValue[status]}</div>
        </Table.Column>

        <Table.Column className='py-[22px] flex items-center justify-end dark:text-dark-10'>
          <div>{writerIncomeSummary.toLocaleString()}</div>
        </Table.Column>

        <Table.Column className='py-[22px] flex items-center desktop:pl-[80px] pl-[60px] dark:text-dark-10'>
          <div>{formatDate(paidAt)}</div>
        </Table.Column>

        <Table.Column className='py-[22px] flex items-center justify-end dark:text-dark-10'>
          <ChevronDownIcon
            width='24'
            height='24'
            className={cn('text-primary transition-all', {
              'rotate-180': isShowSubRow,
            })}
          />
        </Table.Column>
      </Table.Row>
      {isShowSubRow && (
        <div className='flex justify-center w-full'>
          <div className='max-w-[525px] mobile:max-w-[348px] pt-[20px] pb-[40px] font-sarabun text-secondary dark:text-dark-10'>
            <p className='text-[14px] font-bold text-center mb-[29px]'>
              รายได้รวมของนักเขียน (ก่อนหักภาษี ณ ที่จ่าย) ในรอบเดือน{' '}
              {getMonth(paymentCycleMonth)} {paymentCycleYear}
            </p>

            <div className='flex items-center justify-between text-[14px] mb-[12px]'>
              <p className='font-normal'>1. รายได้จากนิยายรายตอน</p>
              <p className='font-light'>
                {writerIncomeNovelChapter.toLocaleString()} บาท
              </p>
            </div>
            <div className='flex items-center justify-between text-[14px] mb-[12px]'>
              <p className='font-normal'>2. รายได้จากการ์ตูนรายตอน</p>
              <p className='font-light'>
                {writerIncomeMangaChapter.toLocaleString()} บาท
              </p>
            </div>
            {SHOW_EBOOK_FEATURE ? (
              <>
                <div className='flex items-center justify-between text-[14px] mb-[12px]'>
                  <p className='font-normal'>3. รายได้จากอีบุ๊กนิยาย</p>
                  <p className='font-light'>
                    {writerIncomeNovelEbook.toLocaleString()} บาท
                  </p>
                </div>
                <div className='flex items-center justify-between text-[14px] mb-[12px]'>
                  <p className='font-normal'>4. รายได้จากอีบุ๊กการ์ตูน</p>
                  <p className='font-light'>
                    {writerIncomeMangaEbook.toLocaleString()} บาท
                  </p>
                </div>
                <div className='flex items-center justify-between text-[14px] mb-[12px]'>
                  <p className='font-normal'>5. รายได้จากการสนับสนุน</p>
                  <p className='font-light'>
                    {writerIncomeDonation.toLocaleString()} บาท
                  </p>
                </div>
                { writerIncomeCumulative > 0 && (<div className='flex items-center justify-between text-[14px] mb-[12px]'>
                  <p className='font-normal'>
                    6. ยอดรายได้สะสมที่ยกมาจากเดือนก่อนหน้า
                  </p>
                  <p className='font-light'>
                    {writerIncomeCumulative.toLocaleString()} บาท
                  </p>
                </div>) }
              </>
            ) : (
              <>
                <div className='flex items-center justify-between text-[14px] mb-[12px]'>
                  <p className='font-normal'>3. รายได้จากการสนับสนุน</p>
                  <p className='font-light'>
                    {writerIncomeDonation.toLocaleString()} บาท
                  </p>
                </div>
                { writerIncomeCumulative > 0 && (<div className='flex items-center justify-between text-[14px] mb-[12px]'>
                  <p className='font-normal'>
                    4. ยอดรายได้สะสมที่ยกมาจากเดือนก่อนหน้า
                  </p>
                  <p className='font-light'>
                    {writerIncomeCumulative.toLocaleString()} บาท
                  </p>
                </div>) }
              </>
            )}
            <div className='flex items-center justify-between text-[14px] mb-[12px]'>
              <p className='font-bold'>รายได้รวมเจ้าของงานเขียนก่อนหักภาษี</p>
              <p className='font-bold'>
                {totalIncomeBeforeDeductWithholdingTax.toLocaleString()} บาท
              </p>
            </div>

            <div className='border-b border-gray-3 dark:border-purple my-[20px]' />

            <p className='text-[14px] font-bold text-center mb-[20px]'>
              การโอนเงินรอบนี้กรุณาออกใบเสร็จรับเงินและจัดส่งเอกสารตามข้อมูลที่ได้ระบุไว้ด้านล่างนี้
            </p>

            <p className='text-primary text-[14px] font-bold'>
              บริษัท อมรินทร์ บุ๊ค เซ็นเตอร์ จำกัด (สำนักงานใหญ่)
            </p>
            <p className='text-primary text-[14px]'>
              108 หมู่ 2 ถนนบางกรวย-จงถนอม ตำบลมหาสวัสดิ์ อำเภอบางกรวย
              จังหวัดนนทบุรี 11130
            </p>
            <p className='text-primary text-[14px] mt-[10px]'>
              <span className='font-bold'>เลขประจำตัวผู้เสียภาษี</span> :
              0105536122664
            </p>


            <div className='border-b border-gray-3 dark:border-purple my-[20px]' />

            <p className='text-secondary-1 text-[14px] font-light'>
              * สำหรับนักเขียนที่มีรายได้ตั้งแต่ 300 บาทขึ้นไป
              ระบบจะโอนภายในวันที่ 15 ของเดือน (กรณีรายได้ไม่ถึง 300 บาท
              ระบบจะสะสมยอดรายได้ในเดือนถัดไป จนถึงยอด 300 บาท)
            </p>
          </div>
        </div>
      )}
    </>
  )
}
